/**
 * デフォルト
 */
import './Default';

/**
 * import
 */
import { MvModule } from './components/parts/mv';
import { MainContentModule } from './components/layout/mainContent';

/**
 * MvModule
 */
new MvModule.Service();

/**
 * MainContentModule
 */
new MainContentModule.Service()